import React from "react";
import LegendV2 from "./legendV2";
import { HandleLegendItemChangeArguments } from "@/types/report";
import { SeriesConfig } from "@/common/type/report-types";

interface LegendWrapperProps {
  position: "right" | "left" | "top" | "bottom";
  items: SeriesConfig;
  onItemChange: (args: HandleLegendItemChangeArguments) => void;
  limit?: number;
}

const LegendWrapperV2: React.FC<LegendWrapperProps> = ({
  position,
  items,
  onItemChange,
  limit = 10,
}) => {
  const isHorizontal = ["top", "bottom"].includes(position);
  const getMargin = () => {
    switch (position) {
      case "top":
        return "10px 0px";
      case "bottom":
        return "10px 0px";
      case "left":
        return "0px 0px 0px 30px";
      case "right":
        return "0px 30px 0px 0px";
      default:
        return "0px 20px";
    }
  };

  // Filter out projected items from the legend display
  const visibleItems = new Map(
    Array.from(items.entries())
      .filter(([key]) => key && !key.endsWith("_projected"))
      .sort(),
  );

  return (
    <div
      style={{
        margin: getMargin(),
        width: isHorizontal ? "80%" : "auto",
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <LegendV2
        items={visibleItems}
        onItemChange={onItemChange}
        direction={isHorizontal ? "horizontal" : "vertical"}
        limit={limit}
      />
    </div>
  );
};

export default LegendWrapperV2;
